var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1385_508)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "url(#paint0_linear_1385_508)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7599 11.8781C10.7599 11.6522 10.7599 11.429 10.7599 11.2057C10.7599 10.272 11.4144 9.79562 12.2943 10.0951C13.9656 10.6667 15.6341 11.2439 17.308 11.8074C17.4288 11.8482 17.587 11.8482 17.7077 11.8074C19.3817 11.2411 21.0502 10.6667 22.7215 10.0923C23.0407 9.98345 23.3572 9.95079 23.6684 10.106C24.0628 10.2992 24.2344 10.6422 24.2505 11.0696C24.2613 11.3391 24.2505 11.6086 24.2505 11.8673C24.4866 11.8999 24.7039 11.9081 24.9078 11.9625C25.5382 12.134 25.9593 12.6812 25.9942 13.34C26.0023 13.5197 25.9996 13.6993 25.9996 13.8817C25.9996 16.8707 25.9996 19.8598 25.9996 22.8515C25.9996 23.6492 25.5891 24.2317 24.8917 24.4196C24.7307 24.4631 24.5563 24.4794 24.3873 24.4794C19.8001 24.4822 15.2103 24.4822 10.6231 24.4794C9.63857 24.4794 9.01084 23.8452 9.01084 22.8488C9.01084 19.7699 9.02962 16.6911 9.00011 13.6122C8.98938 12.5424 9.7405 11.8455 10.6284 11.8972C10.6633 11.8972 10.7009 11.889 10.7599 11.8809V11.8781ZM17.9009 23.513C17.9626 23.4994 17.9921 23.4967 18.0189 23.4858C19.5936 22.9468 21.1656 22.4105 22.7376 21.8688C23.1936 21.7109 23.4592 21.3162 23.4592 20.8207C23.4592 17.6194 23.4592 14.4207 23.4592 11.2194C23.4592 11.1595 23.4619 11.0996 23.4565 11.0397C23.435 10.8546 23.3224 10.7784 23.148 10.8001C23.0675 10.811 22.9924 10.8437 22.9146 10.8682C21.3131 11.4154 19.7116 11.9653 18.1101 12.507C17.9384 12.5641 17.8955 12.6513 17.8955 12.8282C17.9009 16.3072 17.9009 19.7836 17.9009 23.2626C17.9009 23.3361 17.9009 23.4123 17.9009 23.513ZM17.0988 23.5212C17.1042 23.4314 17.1095 23.366 17.1095 23.3007C17.1095 19.7999 17.1095 16.2991 17.1149 12.801C17.1149 12.6376 17.0666 12.5669 16.9137 12.5151C15.2961 11.968 13.6839 11.4126 12.069 10.86C11.6639 10.7212 11.5539 10.8029 11.5539 11.2302C11.5539 14.4153 11.5539 17.6003 11.5539 20.7853C11.5539 21.3352 11.8168 21.7109 12.3265 21.8851C13.3673 22.2445 14.4082 22.6011 15.449 22.9604C15.9936 23.1455 16.5381 23.3307 17.0988 23.5212ZM10.7599 12.7084C10.1456 12.6404 9.79147 12.9317 9.79147 13.4952C9.78879 16.6203 9.78879 19.7454 9.79147 22.8733C9.79147 23.3878 10.0892 23.6818 10.5962 23.6818C12.0019 23.6818 13.4103 23.6818 14.8159 23.6818C14.8669 23.6818 14.9179 23.6737 15.0305 23.6628C14.9205 23.6219 14.8723 23.6029 14.824 23.5865C13.9092 23.2708 12.9918 22.9577 12.077 22.6419C11.2535 22.3588 10.7626 21.6674 10.7626 20.7881C10.7626 18.1883 10.7626 15.5886 10.7626 12.9888V12.7084H10.7599ZM24.2532 12.7084C24.2532 12.8119 24.2532 12.899 24.2532 12.9888C24.2532 15.5804 24.2532 18.172 24.2532 20.7663C24.2532 21.681 23.7757 22.3561 22.9173 22.6474C22.0777 22.9359 21.238 23.2218 20.3984 23.5103C20.2776 23.5512 20.1569 23.6002 20.0389 23.6437C20.0416 23.6573 20.0443 23.6682 20.0469 23.6818C20.1113 23.6818 20.1757 23.6818 20.2401 23.6818C21.6162 23.6818 22.9951 23.6818 24.3712 23.6818C24.94 23.6818 25.2189 23.4014 25.2189 22.827C25.2189 19.7318 25.2189 16.6366 25.2189 13.5414C25.2189 12.9371 24.8783 12.6376 24.2505 12.7111L24.2532 12.7084Z",
    fill: "black",
    stroke: "#252525",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1385_508",
    x: -30,
    y: -30,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1385_508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1385_508",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1385_508",
    x1: 2.26667,
    y1: 2.26667,
    x2: 51.0398,
    y2: 64.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.89710324be305ba17d7b545b37420064.svg";
export { ForwardRef as ReactComponent };